/* eslint-disable react/prop-types */
import classNames from 'classnames'
import dynamic from 'next/dynamic'
import styles from './styles.module.scss'
import { withModifiers } from '../../helpers/withModifiers'
import LazyImage from '../LazyImage'
const CloudflareVideo = dynamic(() => import('../CloudflareVideo'))
const Section = ({
  children,
  className,
  variant = [],
  bg,
  video = false,
  cloudflare,
  separator = false,
  sectionRef,
  grayscale = false,
  ...props
}) => {
  return (
    <section
      ref={sectionRef}
      className={classNames(
        withModifiers(
          'section',
          [...variant, separator && 'has-separator', bg && 'with-bg'],
          styles
        ),
        className
      )}
      {...props}
    >
      {bg && (
        <LazyImage
          src={bg}
          priority
          objectPosition="center"
          objectFit="cover"
          sizes="(max-width: 360px) 960px, (max-width: 640px) 960px, (max-width: 1400px) 1400px, 1980px"
          alt="section background image"
          layout="fill"
        />
      )}

      {(cloudflare || video) && (
        <div
          className={withModifiers(
            'section__video',
            [grayscale && 'grayscale'],
            styles
          )}
        >
          <CloudflareVideo
            name="Section presentation video"
            autoplay
            loop
            muted
            src={cloudflare || video}
          />

          <div className={styles.section__overlay}></div>
        </div>
      )}
      {separator && <div className={styles.section__separator}></div>}
      {children}
    </section>
  )
}

export default Section
